import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { LOGIN } from '../routes';
import { session } from '../services/session';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      session.has('uid') ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: LOGIN,
            state: { from: props.location }
          }}
        />
      )}
  />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.js